'use strict';

/**
 *
 * @name: vimeo
 *
 */

import DirectiveTemplate from './nn-player-vimeo.directive.html';

function VimeoDirective($sce, localPlaylist, $rootScope, $interval) {

  'ngInject';

  return {
    restrict: 'A',
    replace: true,
    template: DirectiveTemplate,
    scope: {
      videoId: '@',
    },
    link: function(scope, element) {

      var player;
      var detached = true;

      if (element[0].parentNode.nodeName === 'DIV') {

        detached = false;
      }

      if (detached) {

        element.parents().remove();
        element.remove();
      }

      function doYourThang() {

        scope.src = $sce.trustAsResourceUrl('//player.vimeo.com/video/' + scope.videoId + '?api=1&player_id=vimeo-player' + scope.videoId + '&autoplay=1');

        setTimeout(function() {

          var iframe = $('#vimeo-player' + scope.videoId)[0];
          console.log(iframe,12309)
          player = $f(iframe);

          player.addEvent('ready', function() {

            $rootScope.noPlayer = false;
            scope.myInterval = $interval(function() {}, 1333);

            player.addEvent('finish', function() {

              $interval.cancel(scope.myInterval);
              $rootScope.$broadcast('filmDun');
              $rootScope.showPersistentVideo = false;
              $rootScope.noPlayer = true;
            });

            player.addEvent('playProgress', function(data) {

              var counter = Math.floor(data.duration - data.seconds);

              if (counter < 0) {

                counter = 0;
              }

              if (counter < 888888) {

                $rootScope.$apply(function() {

                  localPlaylist.updateCounter(counter);
                });
              }
            });
          });

          var vimeoFinishedListener = scope.$on('filmFinished', function() {

            vimeoFinishedListener();
            $interval.cancel(scope.myInterval);
            iframe = null;
            player.removeEvent('playProgress');
            player.removeEvent('finish');
            player.removeEvent('ready');

            scope.$applyAsync(function() {

              element.find('*').remove();
              scope.$destroy();
            });
          });

          scope.$on('$destroy', function() {

            $interval.cancel(scope.myInterval);
            iframe = null;
            element.find('*').remove();
          });
        }, 800);
      }

      if (!detached) {

        doYourThang();
      }
    }
  };
}

export default VimeoDirective;



// WEBPACK FOOTER //
// ./app/components/nn-players/nn-player-vimeo/nn-player-vimeo.directive.js